import styled from 'styled-components'
import Flatpickr from 'react-flatpickr'
import { Button, Card, CardBody } from 'reactstrap'

import { queries } from '~/constants/mediaQuery'

export const OuterContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-end;
`

export const DatePicker = styled(Flatpickr)`
  padding-left: 30px !important;
`

export const FilterCard = styled(Card)`
  display: flex;
  border-radius: 8px;
  width: 100%;
  justify-content: flex-start;
  transition: all 2.75s ease-in-out;

  @media ${queries.less.xll} {
    flex-direction: column !important;
  }
`

export const FilterPanelBody = styled(CardBody)`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
  padding: 20px 25px;
  flex-wrap: nowrap;

  @media (max-width: 1366px) {
    flex-wrap: wrap;
  }

  @media (max-width: 900px) {
    flex-direction: column;

    & > span {
      align-self: flex-start;
    }

    & > div:last-child {
      width: 100%;
      margin: 0 !important;
    }
  }

  > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    gap: 1em;

    @media ${queries.less.xll} {
      flex-direction: column;
    }
  }
`

export const FilterPanelItem = styled.div`
  width: 100%;
`

export const DatePickerContainer = styled.div`
  display: flex;
  text-align: center;
  /* margin-bottom: 1.25rem; */
  align-items: center;
  justify-content: center;
  position: relative;

  svg {
    position: absolute;
    left: 7px;
    pointer-events: none;
  }
`

export const ApplyButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: fit-content;
  width: inherit;

  @media ${queries.less.xll} {
    width: 100%;
    max-width: 100%;
    margin: 0 25px;
  }
`

export const ApplyDiv = styled.div`
  display: flex;
  justify-content: center;
  padding-right: 25px;

  @media ${queries.less.xll} {
    width: 100%;
    max-width: 100%;
    padding-bottom: 20px;
    padding-right: 0;
  }
`
